import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthenticationService } from '../authentication.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {

  username = ''
  password = ''
  invalidLogin = false

  constructor(private router: Router,
    private loginservice: AuthenticationService) { }

  ngOnInit() {
  }

  checkLogin() {
    this.loginservice.authenticate(this.username, this.password).subscribe(
      (response: any) => {
        console.log('response', response.body);  // Debug log to verify the response

        if (response.body) {
          console.log("Entering navigation");  // Check if this log is printed
          sessionStorage.setItem('username', this.username)
          this.router.navigate(['home']);
          this.invalidLogin = false;
        } else {
          console.log("Authentication failed");
          this.invalidLogin = true;
        }
      },
      (error) => {
        // Handle any errors that occur during the authentication request
        console.error('Authentication failed', error);
        this.invalidLogin = true;
      }
    );
  }

}
